module.exports = __webpack_public_path__ + "static/media/Oracle_Logo.836dbadd.png";